import styled from 'styled-components';

export const ChartComponentWrapper = styled.div`
  font-size: 0.875rem;
  width: 74.063rem;
  height: 26.5rem;
  background-color: white;
  border-radius: 0.625rem;
  box-shadow: 0.188rem 0.188rem 0.313rem rgba(0, 0, 0, 0.25);
  padding: 2rem 0rem 1rem 2rem;
  display: flex;
  overflow: hidden;
`;
export const WrapperFilter = styled.div`
  width: 26.125rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 5.125rem;
`;
export const SwitchWrapper = styled.div`
  margin-top: 7.188rem;
`;
export const LoadingWrapperChart = styled.div`
  width: 74.063rem;
  height: 26.5rem;
  background-color: rgb(255, 255, 255, 0.5);
  margin-top: -2rem;
  margin-left: -2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 2;
  border-radius: 0.625rem;
`;
export const PrepaidUsage = styled.div`
  position: absolute;
  margin-top: -1.5rem;
  margin-left: -0.5rem;
  color: #868686;
  font-size: 0.75rem;
`;
